import { ExtensionEndpoint as ExtensionEndpointLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { ALL_VALUE } from '../../Common/API/ItemsGetters'
import { SelectItem, SelectOption } from '../../Common/Components/Selects/Types'
import { SERVER_NONE_VALUE } from '../Constants'

/**
 * Constructs the default values for the extension endpoints.
 */
export class ExtensionEndpointsDefaults {
    public static INSTANCE: ExtensionEndpointsDefaults

    private language: CLanguageHandler

    constructor(language: CLanguageHandler) {
        this.language = language

        this.language.loadBundle('ExtensionEndpoint')
    }

    public getNoneTelServersOption(): SelectOption<number> {
        return {
            label: this.language.get(ExtensionEndpointLanguage.NoneSelected),
            value: ALL_VALUE
        }
    }

    public getNonePartitionOption(): SelectOption<number> {
        return {
            label: this.language.get(ExtensionEndpointLanguage.NoneSelected),
            value: ALL_VALUE
        }
    }

    public getNoDevice(): SelectItem {
        return {
            label: this.language.get(ExtensionEndpointLanguage.NoAssociatedDevice),
            value: SERVER_NONE_VALUE
        }
    }

    public getNoAgent(): SelectItem {
        return {
            label: this.language.get(ExtensionEndpointLanguage.NoAssociatedAgent),
            value: SERVER_NONE_VALUE
        }
    }

    public static getInstance(language: CLanguageHandler): ExtensionEndpointsDefaults {
        if (!this.INSTANCE) {
            this.INSTANCE = new ExtensionEndpointsDefaults(language)
        }

        return this.INSTANCE
    }
}
